export default "__VITE_ASSET__FL72pjEe__"